
import getPages from 'utils/getPages'
import loadPages from 'utils/loadPages'
import { getCustomData } from 'shared/components/App/Auth'

const getCurrentPage = async (curLoc: any) => {

    const curBasepath = '/' + curLoc.pathname.split('/')[1]
    let pages: any = await getPages()
    if (!pages.length) {
        pages = await loadPages({
            role: getCustomData('role'),
            customer: getCustomData('customer') ?? false,
            loadFromServer: true
        })
    }
    const curPage = pages.find(item => {
        if (typeof item.path === 'string')
            return '/' + item.path.split('/')[1] === curBasepath
        else
            return false
    })

    return curPage ?? null
}

export default getCurrentPage